<template>
  <div>
    <preloader :is-visible="isLoading"></preloader>
    <div class="uk-overflow-auto">
      <table class="uk-table uk-table-small uk-table-divider uk-table-hover tm-admin-ratings-table uk-table-middle uk-text-small">
        <thead>
          <tr>
            <th class="uk-text-center uk-table-middle">
              Имя
            </th>
            <th class="uk-text-center uk-table-middle">
              <div class="uk-grid uk-grid-collapse uk-flex-center" data-uk-grid>
                <div>
                  Роль
                </div>
                <AdminOrderHistoryTableHeader :sort_by="sort_by"
                                              value="roles[0].name"
                                              @sortBy="onSortBy"></AdminOrderHistoryTableHeader>
              </div>
            </th>
            <th class="uk-text-center uk-table-middle">
              Показатели
            </th>
            <th class="uk-text-center uk-table-middle" v-for="item in getPeriods" :key="item.week" :data-uk-tooltip="`title:  ${item.start ? item.start : '-' } / ${ item.end ? item.end : '-' }; offset: 5'`">
              {{item.week}}
            </th>
            <th class="uk-table-expand"></th>
          </tr>
          <button class="uk-button uk-button-success uk-button-small"
                  style="position: absolute;right: 6px;top: 5px;"
                  data-uk-tooltip="title: Добавить неделю; offset: 8"
                  @click="$emit('loadCommonMore')">
            <md-icon>add</md-icon>
            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left uk-light" data-uk-spinner="ratio: 0.7"></span>
          </button>
        </thead>
        <tbody>
          <tr v-for="(item,index) in  usersForCommonRating" :key="index">
            <td class="uk-text-truncate" :data-uk-tooltip="'title: ' + item.email + '; offset: 5'">{{ item.email }}</td>
            <td>{{ item.roles[0].name }}</td>
            <td>
              <div style="color: red;">
                #
              </div>
              <div style="color: green;">
                % премия
              </div>
              <div>
                % возвратов
              </div>
            </td>
            <td class="uk-text-center" v-for="(i, index2) in getPeriods" :key="index2">
              <div style="color: red;">
                {{
                  (getItemsByWeek(i.week, item.email, 'total_orders_last_week')) ? getItemsByWeek(i.week, item.email, 'total_orders_last_week') : '-'
                }}
              </div>
              <div style="color: green;">
                {{
                  (getItemsByWeek(i.week, item.email, 'salary_bonus')) ? getItemsByWeek(i.week, item.email, 'salary_bonus') : '-'
                }}
              </div>
              <div>
                {{
                  (getItemsByWeek(i.week, item.email, 'adjusted_percent_returning')) ? getItemsByWeek(i.week, item.email, 'adjusted_percent_returning') : '-'
                }}
              </div>
            </td>
            <td class="uk-table-expand"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AdminOrderHistoryTableHeader from "./../Components/AdminOrderHistoryTableHeader.vue";
import Preloader from "@/pages/Dashboard/Components/Preloader";

export default {
  props: {
    commonItems: {type: [Array, Object]},
    loading: Boolean,
  },
  components: {AdminOrderHistoryTableHeader, Preloader},
  data() {
    return {
      sort_by: {
        column: 'created_at',
        order: 'desc'
      },
      usersForCommonRating: [],
      isLoading: true,
    };
  },
  methods: {
    getItemsByWeek(week, email, param) {
      for (const item of this.commonItems) {
        if (item.date.week === week) {
          for (const r of item.rating) {
            if (r.email === email)
              return r[param] ? Math.round(r[param]) : '-';
          }
        }
      }
    },
    onSortBy(data) {
      let column = data.column;
      let order = data.order;

      if (this.sort_by.column === column) {
        this.sort_by.order = order === 'desc' ? 'asc' : 'desc';
      } else {
        this.sort_by.column = column;
        this.sort_by.order = order;
      }
      this.usersForCommonRating = _.orderBy(this.usersForCommonRating, this.sort_by.column, this.sort_by.order);
    },
    async getCommonMoreUsers(newRequest = false) {
      this.loadingCommonRaw = true;
      let error = "";
      await this.$store.dispatch('rating/adminCommonRatingDataUsers', {
        page: this.page,
        new: newRequest
      }).catch((reason => {
        error = true;
      }));
      if (!error) {
        this.usersForCommonRating = await this.$store.getters['rating/adminCommonRatingDataUsers'];
      }
      this.loadingCommonRaw = false;
    },
  },
  computed: {
    getPeriods() {
      let periods = [];
      for (const date of this.commonItems) {
        periods.push(date.date)
      }
      return periods;
    },
  },
  created() {
    this.getCommonMoreUsers()
    this.isLoading = false;
  }
}
</script>